enum EconomicGroupGroupingTypesEnum {
  COMPANY = 'company',
  CUSTOMER = 'customer',
}

export default EconomicGroupGroupingTypesEnum;
